var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Image"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 126 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 17.3165C43.59 17.3165 17.3165 43.59 17.3165 76C17.3165 108.41 43.59 134.684 76 134.684C108.41 134.684 134.684 108.41 134.684 76C134.684 43.59 108.41 17.3165 76 17.3165ZM0 76C0 34.0264 34.0264 0 76 0C117.974 0 152 34.0264 152 76C152 117.974 117.974 152 76 152C34.0264 152 0 117.974 0 76Z",
    fill: "#0071BA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 169 (Stroke)",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.983 22.7381C152.365 26.1193 152.365 31.6014 148.983 34.9827L78.2745 105.692C74.8933 109.073 69.4112 109.073 66.0299 105.692L41.9793 81.6409C38.598 78.2596 38.598 72.7776 41.9793 69.3963C45.3605 66.0151 50.8426 66.0151 54.2239 69.3963L72.1522 87.3247L136.739 22.7381C140.12 19.3568 145.602 19.3568 148.983 22.7381Z",
    fill: "#182857"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.aa2bc515d8c947791a0edde6fceb4215.svg";
export { ForwardRef as ReactComponent };